import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import {waitForImages} from '../../../appointment-management/components/digital-vos-form/exportDigitalVosPdf'

const PDF_WIDTH_MM = 297
const LAYER_TRANSLATE = /translate\(([-\d.]+)px,\s*([-\d.]+)px\)/

function positionLayersWithoutTransform(clonedRoot: HTMLElement) {
  clonedRoot.style.boxShadow = 'none'
  clonedRoot.querySelectorAll<HTMLElement>('.cert-canvas-layer').forEach((layer) => {
    const match = LAYER_TRANSLATE.exec(layer.style.transform)
    if (!match) return
    layer.style.transform = 'none'
    layer.style.left = `${match[1]}px`
    layer.style.top = `${match[2]}px`
  })
}

function containImages(clonedRoot: HTMLElement, naturalSizes: Array<[number, number]>) {
  clonedRoot.querySelectorAll('img').forEach((img, index) => {
    const [naturalWidth, naturalHeight] = naturalSizes[index] ?? [0, 0]
    const box = img.parentElement
    if (!box || !naturalWidth || !naturalHeight) return
    const boxWidth = box.clientWidth
    const boxHeight = box.clientHeight
    const ratio = Math.min(boxWidth / naturalWidth, boxHeight / naturalHeight)
    const width = naturalWidth * ratio
    const height = naturalHeight * ratio
    img.style.position = 'absolute'
    img.style.width = `${width}px`
    img.style.height = `${height}px`
    img.style.left = `${(boxWidth - width) / 2}px`
    img.style.top = `${(boxHeight - height) / 2}px`
    img.style.objectFit = 'fill'
  })
}

export async function buildCertificatePdf(
  element: HTMLElement,
  widthPx: number,
  heightPx: number
): Promise<jsPDF> {
  await waitForImages(element)
  const naturalSizes = Array.from(element.querySelectorAll('img')).map((img): [number, number] => [
    img.naturalWidth,
    img.naturalHeight,
  ])

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
    logging: false,
    onclone: (_document, clonedElement) => {
      positionLayersWithoutTransform(clonedElement)
      containImages(clonedElement, naturalSizes)
    },
  })

  const pdfH = (heightPx / widthPx) * PDF_WIDTH_MM
  const pdf = new jsPDF({
    orientation: PDF_WIDTH_MM > pdfH ? 'landscape' : 'portrait',
    unit: 'mm',
    format: [PDF_WIDTH_MM, pdfH],
  })
  pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, PDF_WIDTH_MM, pdfH)
  return pdf
}

export function saveCertificatePdf(pdf: jsPDF, fileName: string) {
  const url = URL.createObjectURL(pdf.output('blob'))
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
